import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { first } from 'lodash';
import { IRuleProps } from './types';
import { RuleValue } from './RuleValue';
import MembershipRuleIcon from '../../../../assets/icons/rule-part-of-audience.svg?react';
import { useWorkspace } from '@/features/workspaces/hooks';
import { SpinnerIcon } from '@/components/icons';
import { useGetAudienceQuery } from '@/services/endpoints/audiences';

export const MembershipRule: FC<IRuleProps> = ({ expression }) => {
  const { t } = useTranslation('audience');
  const workspace = useWorkspace();

  const label = expression.membership === 'IN' ? 'rules.belongs_to' : 'rules.not_belongs_to';

  const { isLoading, data } = useGetAudienceQuery({
    audienceId: first(expression.audienceIds),
    workspaceId: workspace.id,
  });

  const renderAudienceName = () => {
    return isLoading ? <SpinnerIcon className='ml-2 size-4' loading /> : <RuleValue>{data.name}</RuleValue>;
  };

  return (
    <div className='flex flex-col gap-1.5'>
      <div className='flex gap-2 text-sm font-medium text-tertiary-600'>
        <MembershipRuleIcon className='text-brand-500' />
        {t(label)}
      </div>
      {renderAudienceName()}
    </div>
  );
};
